// Shared ref to track if the page has finished loading
export const pageLoadCompleteRef = { current: false };
